export const mockData = {
  id: '7399d4ad-7918-451b-83f4-9e01279a7be9',
  transactionAccountNumber: 'AC-3Z6W-A65R-FC8P',
  billToParty: {
    name: 'MK Shared Corp Payment Terms 1',
    taxId: '12345678',
    state: 'IL',
    addressLine1: '796 Mcallister',
    addressLine2: null,
    city: 'San Francisco',
    country: 'US',
    taxExempt: null,
    taxIds: [
      {
        id: '12345678',
        label: 'vatNumber',
        displayName: null,
        metadata: {
          vatStatus: null,
        },
        taxExempt: false,
      },
    ],
    taxLabels: [
      {
        region: 'XX',
        taxIdLabels: [
          {
            type: 'vatNumber',
            displayName: 'EIN',
            description: 'Employer Identification number',
            metadata: null,
          },
        ],
      },
    ],
  },
  billingAccountsList: {
    totalCount: 2,
    totalCreditLimit: 100000,
    creditOutstanding: 1136.75,
    availableCreditLimit: 98863.25,
    paymentMethod: 'NET30',
    currency: 'USD',
    status: 'ELIGIBLE',
    nodes: [
      {
        creditOutstanding: 0,
        status: 'ELIGIBLE',
        customerName: 'MK Shared Corp Payment Terms 2',
        transactionAccountNumber: 'AC-3Z6W-AHZ5-8AVN',
        pendingInvoiceRequestsTotal: 100,
        taxId: '12345678',
      },
      {
        creditOutstanding: 1136.75,
        status: 'ELIGIBLE',
        customerName: 'MK Shared Corp Payment Terms 1',
        transactionAccountNumber: 'AC-3Z6W-A65R-FC8P',
        pendingInvoiceRequestsTotal: 200,
        taxId: '12345678',
      },
    ],
  },
};

export const mockDataWithMissingFields = {
  id: '7399d4ad-7918-451b-83f4-9e01279a7be9',
  transactionAccountNumber: 'AC-3Z6W-A65R-FC8P',
  billToParty: {
    name: 'MK Shared Corp Payment Terms 1',
    taxId: '12345678',
    state: 'IL',
    taxExempt: null,
    taxIds: [
      {
        id: '12345678',
        label: 'vatNumber',
        displayName: null,
        metadata: {
          vatStatus: null,
        },
        taxExempt: false,
      },
    ],
    taxLabels: [
      {
        region: 'XX',
        taxIdLabels: [
          {
            type: 'vatNumber',
            displayName: 'EIN',
            description: 'Employer Identification number',
            metadata: null,
          },
        ],
      },
    ],
  },
  billingAccountsList: {
    totalCount: 2,
    totalCreditLimit: null,
    creditOutstanding: null,
    availableCreditLimit: null,
    paymentMethod: 'NET30',
    currency: 'USD',
    status: 'ELIGIBLE',
    nodes: [
      {
        creditOutstanding: 0,
        status: 'ELIGIBLE',
        customerName: 'MK Shared Corp Payment Terms 2',
        transactionAccountNumber: 'AC-3Z6W-AHZ5-8AVN',
        pendingInvoiceRequestsTotal: 0,
        taxId: '12345678',
      },
    ],
  },
};

export const currentTxaDataMockedWithMissingFields = [
  {
    creditOutstanding: 0,
    status: 'ELIGIBLE',
    customerName: 'MK Shared Corp Payment Terms 2',
    transactionAccountNumber: 'AC-3Z6W-AHZ5-8AVN',
    pendingInvoiceRequestsTotal: 100,
    taxId: '12345678',
  },
];

export const currentTxaDataMocked = [
  {
    creditOutstanding: 1000,
    status: 'ELIGIBLE',
    customerName: 'MK Shared Corp Payment Terms 2',
    transactionAccountNumber: 'AC-3Z6W-AHZ5-8AVN',
    pendingInvoiceRequestsTotal: 100,
    taxId: '12345678',
  },
];
